export default "__VITE_ASSET__dbcdd745__"